export default class Parallax {

	constructor(className = null) {
		if (!gsap || !className) return;

		gsap.utils.toArray(className).forEach((section, i) => {
			section.bg = section.querySelector(".bg");

			// use function-based values in order to keep things responsive
			gsap.fromTo(section.bg, {
				backgroundPosition: `50% ${-window.innerHeight * this.getRatio(section)}px`
			}, {
				backgroundPosition: `50% ${window.innerHeight * (1 - this.getRatio(section))}px`,
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true // to make it responsive
				}
			});

		});
	}

	getRatio = el => window.innerHeight / (window.innerHeight + el.offsetHeight);

}
